// モーダル
$(function () {
	var scrollPos; // topからのスクロール位置

	$('.modal_open').each(function () {
		$(this).on('click', function () {
			var target = $(this).data('target');
			var modal = document.getElementById(target);

			scrollPos = $(window).scrollTop(); // スクロール位置を格納
			$('body').addClass('fixed').css({ top: -scrollPos }); // 背景固定
			$(modal).addClass('is_open'); // モーダル表示

			// アコーディオン初期化（すべて閉じる／ヒントは表示に戻す）
			$(modal).find('.accordion_btn').removeClass('active');
			$(modal).find('.accordion_content').hide();
			$(modal).find('.accordion_box.hint_box').show(); // ヒントボックスを表示に戻す

			// --- ヒントまたはこたえボタンで開くとアコーディオンを展開 ---
      if ($(this).hasClass('modal_hint')) {

        // ヒント(1)だけ開く（ヒント(2)は閉じたまま）
        $(modal).find('.accordion_box.hint_box').eq(0).find('.accordion_btn')
          .addClass('active')
          .next('.accordion_content').slideDown(0);

        // 念のため2つ目以降は閉じる（表示はしたまま）
        $(modal).find('.accordion_box.hint_box').slice(1).each(function () {
          $(this).find('.accordion_btn').removeClass('active');
          $(this).find('.accordion_content').hide();
        });

      } else if ($(this).hasClass('modal_answer')) {
        $(modal).find('.accordion_box.answer_box .accordion_btn')
          .addClass('active')
          .next('.accordion_content').slideDown(0);

				// ヒントを非表示にする
				$(modal).find('.accordion_box.hint_box').hide();
			}
			// ------------------------------------------------------------

			return false;
		});
	});

	$('.modal_mask, .modal_close').on('click', function () {
		$('body').removeClass('fixed').css({ top: 0 }); // 背景固定解除
		$(window).scrollTop(scrollPos); // 元の位置まで戻す
		$('.modal_wrapper').removeClass('is_open'); // モーダル閉じる

		// アコーディオン状態をリセット
		$('.accordion_btn.active').removeClass('active').next('.accordion_content').slideUp(0);

		// ヒントを閉じた場合でも表示に戻す（他のモーダルで必要になる可能性があるため）
		$('.accordion_box.hint_box').show();

		return false;
	});
});

// モーダル内の高さ調整
const setFillHeight = () => {
	const vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
};

// リサイズ対応
let vw = window.innerWidth;
window.addEventListener('resize', () => {
	if (vw === window.innerWidth) {
		return;
	}
	vw = window.innerWidth;
	setFillHeight();
});

// 実行
setFillHeight();


// アコーディオン
$(function () {
	$('.accordion_btn').on('click', function () {
		$(this).next('.accordion_content').slideToggle(300);
		$(this).toggleClass('active');
	});
	$('.modal_mask, .modal_close').on('click', function () {
		$('.accordion_btn.active').removeClass('active').next('.accordion_content').slideUp(300);
	});
});


//もっと　みる
$('.more_content:not(.more_content:first-of-type)').css('display','none');
$('.btn_more').nextAll('.btn_more').css('display','none');
$('.btn_more').on('click', function() {
	$(this).css('display','none');
	$(this).next('.more_content').slideDown('fast');
	$(this).nextAll('.btn_more:first').css('display','block');
});



//ボタンクリックで音楽再生
document.addEventListener('DOMContentLoaded', () => {
  const playLists = document.querySelectorAll('.playlist');

  playLists.forEach((playList) => {
    const tracks = playList.querySelectorAll('.tracks');

    tracks.forEach((track) => {
      // audio タグを挿入
      const audioElem = `<audio></audio>`;
      track.insertAdjacentHTML('afterbegin', audioElem);

      const playBtn = track.querySelector('button.play');
      const audio = track.querySelector('audio');

      // データ属性から音源セット
      audio.src = track.dataset.audioSrc;

      // 再生終了時の処理
      audio.addEventListener('ended', () => {
        playBtn.classList.remove('playing');
        playBtn.setAttribute('aria-label', 'Play');
      });

      // 再生ボタンクリック時のトグル処理
      playBtn.addEventListener('click', () => {
        toggleBtn(track);
      });
    });

    // 再生処理
    async function playAudio(track) {
      const audio = track.querySelector('audio');
      try {
        await audio.play();
        const btn = track.querySelector('button.play');
        btn.classList.add('playing');
        btn.setAttribute('aria-label', 'Pause');
      } catch (err) {
        console.warn(err);
      }
    }

    // トグル処理：再生中なら止めて再スタート、停止中なら再生
    function toggleBtn(track) {
      const btn = track.querySelector('button.play');
      const audio = track.querySelector('audio');

      if (audio.paused) {
        playAudio(track);
      } else {
        audio.pause();
        audio.currentTime = 0;
        //playAudio(track);
      }
    }
  });

  // 全体で再生イベントを監視し、他の音声を停止する処理（playlistをまたいでも動作）
  document.addEventListener('play', (e) => {
    const audios = document.querySelectorAll('audio');
    audios.forEach((audio) => {
      if (audio !== e.target) {
        audio.pause();
        audio.currentTime = 0;
        const parent = audio.parentElement;
        const btn = parent.querySelector('button.play');
        if (btn) {
          btn.classList.remove('playing');
          btn.setAttribute('aria-label', 'Play');
        }
      }
    });
  }, true); // useCapture: true でバブリング前に検知
});


// ジェスチャークイズの画像切り替え
const click_gesture_img = document.getElementsByClassName("card_gesture");
const click_gesture_imgs = Array.from(click_gesture_img);

click_gesture_imgs.forEach(function(gesture) {
  gesture.addEventListener("click", function() {

    clik_id = gesture.id;
    fp = "https://cdn.shopify.com/s/files/1/0595/0324/7449/files/";

    if(gesture.src.endsWith("png")){

      if(clik_id === "beginner1"){
        fn = "card_gesture-beginner_gif1.gif";
      } else if(clik_id === "beginner2") {
        fn = "card_gesture-beginner_gif2.gif";
      } else if(clik_id === "sp-advanced1") {
        fn = "card_gesture-super-advanced_gif1.gif";
      } else if(clik_id === "sp-advanced2") {
        fn = "card_gesture-super-advanced_gif2.gif";
      }

    } else {

      if(clik_id === "beginner1"){
        // 1～10
        rand = Math.floor( Math.random() * 10 ) + 1;
        fn = "card_gesture-beginner_0";
      } else if(clik_id === "beginner2") {
        // 11～50
        rand = Math.floor( Math.random() * 40 ) + 11;
        fn = "card_gesture-beginner_0";
      } else if(clik_id === "sp-advanced1") {
        // 1～10
        rand = Math.floor( Math.random() * 10 ) + 1;
        fn = "card_gesture-super-advanced_0";
      } else if(clik_id === "sp-advanced2") {
        // 11～50
        rand = Math.floor( Math.random() * 40 ) + 11;
        fn = "card_gesture-super-advanced_0";
      }

      if(rand.toString().length === 1) {
        fn = fn + "0" + rand + ".png";
      } else {
        fn = fn + rand + ".png";
      }

    }

    document.getElementById(clik_id).src = fp + fn;

  });
});


// お絵描きクイズの画像切り替え
const click_drawing_img = document.getElementsByClassName("card_drawing");
const click_drawing_imgs = Array.from(click_drawing_img);

click_drawing_imgs.forEach(function(drawing) {
  drawing.addEventListener("click", function() {

    clik_id = drawing.id;
    fp = "https://cdn.shopify.com/s/files/1/0595/0324/7449/files/";

    if(drawing.src.endsWith("png")){

      if(clik_id === "beginner_topic"){
        fn_t = "card_drawing-beginner_gif.gif";
      } else if(clik_id === "intermediate_topic") {
        fn_t = "card_drawing-intermediate_gif.gif";
      } else if(clik_id === "super-advanced_topic") {
        fn_t = "card_drawing-super-advanced_gif.gif";
      }

    } else {

      if(clik_id === "beginner_topic"){
        // 1～20
        rand = Math.floor( Math.random() * 20 ) + 1;
        fn_c = "card_drawing-beginner_0";
        fn_t = "text_drawing-beginner_0";
        answer_id = "beginner_answer";
      } else if(clik_id === "intermediate_topic") {
        // 1～19
        rand = Math.floor( Math.random() * 19 ) + 1;
        fn_c = "card_drawing-intermediate_0";
        fn_t = "text_drawing-intermediate_0";
        answer_id = "intermediate_answer";
      } else if(clik_id === "super-advanced_topic") {
        // 1～40
        rand = Math.floor( Math.random() * 40 ) + 1;
        fn_c = "card_drawing-super-advanced_0";
        fn_t = "text_drawing-super-advanced_0";
        answer_id = "super-advanced_answer";
      }

      if(rand.toString().length === 1) {
        fn_c = fn_c + "0" + rand + ".png";
        fn_t = fn_t + "0" + rand + ".png";
      } else {
        fn_c = fn_c + rand + ".png";
        fn_t = fn_t + rand + ".png";
      }


    }

    document.getElementById(clik_id).src = fp + fn_t;
    document.getElementById(answer_id).src = fp + fn_c;
    document.getElementById("ac_cont").style.display = "none";

  });
});

